import { defineComponent as j, watchEffect as x, ref as v, toRef as U, computed as V, h as u, nextTick as E } from "vue";
import K from "./ghl-ui.es966.js";
import _ from "./ghl-ui.es967.js";
import { warnOnce as L } from "./ghl-ui.es825.js";
import $ from "./ghl-ui.es826.js";
import H from "./ghl-ui.es879.js";
import M from "./ghl-ui.es861.js";
import k from "./ghl-ui.es827.js";
import W from "./ghl-ui.es696.js";
import { smallerSize as q } from "./ghl-ui.es968.js";
import { useThemeClass as G } from "./ghl-ui.es829.js";
import J from "./ghl-ui.es353.js";
import Q from "./ghl-ui.es375.js";
import X from "./ghl-ui.es196.js";
import Y from "./ghl-ui.es242.js";
import Z from "./ghl-ui.es834.js";
import ee from "./ghl-ui.es969.js";
import te from "./ghl-ui.es970.js";
import { call as N } from "./ghl-ui.es866.js";
const ne = Object.assign(Object.assign(Object.assign({}, k.props), K), {
  size: {
    type: String,
    default: "medium"
  },
  closable: {
    type: Boolean,
    default: !0
  },
  defaultValue: {
    type: Array,
    default: () => []
  },
  value: Array,
  inputClass: String,
  inputStyle: [String, Object],
  inputProps: Object,
  max: Number,
  tagClass: String,
  tagStyle: [String, Object],
  renderTag: Function,
  onCreate: {
    type: Function,
    default: (t) => t
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  // deprecated
  onChange: [Function, Array]
}), Te = j({
  name: "DynamicTags",
  props: ne,
  setup(t) {
    process.env.NODE_ENV !== "production" && x(() => {
      t.onChange !== void 0 && L("dynamic-tags", "`on-change` is deprecated, please use `on-update:value` instead.");
    });
    const {
      mergedClsPrefixRef: y,
      inlineThemeDisabled: d
    } = $(t), {
      localeRef: c
    } = H("DynamicTags"), m = M(t), {
      mergedDisabledRef: i
    } = m, f = v(""), p = v(!1), g = v(!0), C = v(null), b = k("DynamicTags", "-dynamic-tags", _, te, t, y), R = v(t.defaultValue), O = U(t, "value"), s = W(O, R), F = V(() => c.value.add), z = V(() => q(t.size)), D = V(() => i.value || !!t.max && s.value.length >= t.max);
    function T(e) {
      const {
        onChange: n,
        "onUpdate:value": a,
        onUpdateValue: l
      } = t, {
        nTriggerFormInput: B,
        nTriggerFormChange: P
      } = m;
      n && N(n, e), l && N(l, e), a && N(a, e), R.value = e, B(), P();
    }
    function I(e) {
      const n = s.value.slice(0);
      n.splice(e, 1), T(n);
    }
    function w(e) {
      switch (e.key) {
        case "Enter":
          o();
      }
    }
    function o(e) {
      const n = e ?? f.value;
      if (n) {
        const a = s.value.slice(0);
        a.push(t.onCreate(n)), T(a);
      }
      p.value = !1, g.value = !0, f.value = "";
    }
    function A() {
      o();
    }
    function S() {
      p.value = !0, E(() => {
        var e;
        (e = C.value) === null || e === void 0 || e.focus(), g.value = !1;
      });
    }
    const h = V(() => {
      const {
        self: {
          inputWidth: e
        }
      } = b.value;
      return {
        "--n-input-width": e
      };
    }), r = d ? G("dynamic-tags", void 0, h, t) : void 0;
    return {
      mergedClsPrefix: y,
      inputInstRef: C,
      localizedAdd: F,
      inputSize: z,
      inputValue: f,
      showInput: p,
      inputForceFocused: g,
      mergedValue: s,
      mergedDisabled: i,
      triggerDisabled: D,
      handleInputKeyDown: w,
      handleAddClick: S,
      handleInputBlur: A,
      handleCloseClick: I,
      handleInputConfirm: o,
      mergedTheme: b,
      cssVars: d ? void 0 : h,
      themeClass: r == null ? void 0 : r.themeClass,
      onRender: r == null ? void 0 : r.onRender
    };
  },
  render() {
    const {
      mergedTheme: t,
      cssVars: y,
      mergedClsPrefix: d,
      onRender: c,
      renderTag: m
    } = this;
    return c == null || c(), u(J, {
      class: [`${d}-dynamic-tags`, this.themeClass],
      size: "small",
      style: y,
      theme: t.peers.Space,
      themeOverrides: t.peerOverrides.Space,
      itemStyle: "display: flex;"
    }, {
      default: () => {
        const {
          mergedTheme: i,
          tagClass: f,
          tagStyle: p,
          type: g,
          round: C,
          size: b,
          color: R,
          closable: O,
          mergedDisabled: s,
          showInput: F,
          inputValue: z,
          inputClass: D,
          inputStyle: T,
          inputSize: I,
          inputForceFocused: w,
          triggerDisabled: o,
          handleInputKeyDown: A,
          handleInputBlur: S,
          handleAddClick: h,
          handleCloseClick: r,
          handleInputConfirm: e,
          $slots: n
        } = this;
        return this.mergedValue.map((a, l) => m ? m(a, l) : u(Q, {
          key: l,
          theme: i.peers.Tag,
          themeOverrides: i.peerOverrides.Tag,
          class: f,
          style: p,
          type: g,
          round: C,
          size: b,
          color: R,
          closable: O,
          disabled: s,
          onClose: () => {
            r(l);
          }
        }, {
          default: () => typeof a == "string" ? a : a.label
        })).concat(F ? n.input ? n.input({
          submit: e,
          deactivate: S
        }) : u(X, Object.assign({
          placeholder: "",
          size: I,
          style: T,
          class: D,
          autosize: !0
        }, this.inputProps, {
          ref: "inputInstRef",
          value: z,
          onUpdateValue: (a) => {
            this.inputValue = a;
          },
          theme: i.peers.Input,
          themeOverrides: i.peerOverrides.Input,
          onKeydown: A,
          onBlur: S,
          internalForceFocus: w
        })) : n.trigger ? n.trigger({
          activate: h,
          disabled: o
        }) : u(Y, {
          dashed: !0,
          disabled: o,
          theme: i.peers.Button,
          themeOverrides: i.peerOverrides.Button,
          size: I,
          onClick: h
        }, {
          icon: () => u(Z, {
            clsPrefix: d
          }, {
            default: () => u(ee, null)
          })
        }));
      }
    });
  }
});
export {
  Te as default,
  ne as dynamicTagsProps
};
